import { HgSupportedLanguage } from '@smg-real-estate/domus';
import type { GeoLocation } from '@smg-real-estate/geo-libs';
import type { Composer } from 'vue-i18n';

import { countryTextMapping } from '@/helpers/SEO/metaInfoHelper';
import { getBasePathWithLocation } from '@/router';

export function getDirectoryLocationsSeoLabel(
  searchedLocations: GeoLocation[] | null | undefined,
  language: HgSupportedLanguage,
): string {
  return searchedLocations && searchedLocations.length > 0
    ? searchedLocations.map((item) => item.names[language]).join(',')
    : countryTextMapping[language];
}

export function getAgencyDirectoryPageTitle(
  t: Composer['t'],
  currentPage: number,
  locationLabel: string,
): string {
  return currentPage > 1
    ? t('seo.pageTitleWithPageLocationSpecific', {
        page: currentPage,
        location: locationLabel,
      }).toString()
    : t('seo.pageTitleLocationSpecific', { location: locationLabel }).toString();
}

export function getAgencyDirectoryPageDescription(t: Composer['t'], locationLabel: string): string {
  return t('seo.pageDescriptionLocationSpecific', { location: locationLabel }).toString();
}

export function localizeDirectoryHreflangCode(locale: HgSupportedLanguage): string {
  return locale === HgSupportedLanguage.EN ? locale : `${locale}-CH`;
}

export function buildAgencyDirectorySeoLinks(
  canonicalHref: string,
  searchedLocations: GeoLocation[] | null | undefined,
) {
  const baseUrl = import.meta.env.VUE_APP_BASE_URL;

  return [
    { rel: 'canonical' as const, href: canonicalHref },
    ...Object.values(HgSupportedLanguage).map((lang) => ({
      rel: 'alternate' as const,
      hreflang: localizeDirectoryHreflangCode(lang),
      href: `${baseUrl}${getBasePathWithLocation(lang, searchedLocations?.[0]?.urlNames?.[lang])}`,
    })),
    {
      rel: 'alternate' as const,
      hreflang: 'x-default',
      href: `${baseUrl}${getBasePathWithLocation(
        HgSupportedLanguage.DE,
        searchedLocations?.[0]?.urlNames?.[HgSupportedLanguage.DE],
      )}`,
    },
  ];
}
